import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import GridOnIcon from '@mui/icons-material/GridOn';
import SummarizeIcon from '@mui/icons-material/Summarize';
import InfoIcon from '@mui/icons-material/Info';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Maybe } from 'graphql/jsutils/Maybe';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import BreadCrumbs from '../components/BreadCrumbs';
import { Layout } from '../components/Layout';
import { FixedTrafficOverview } from './FixedTrafficOverview';
import { ManualCMR } from './ManualCMR';
import { TruckFillAndTime } from './TruckFillAndTime';
import { ViewReportFromTerminal } from './ViewReportFromTerminal';
import { RemainingGoodsInTerminal } from './RemainingGoodsInTerminal';
import { ReportToTrafficInTerminal } from './ReportToTrafficInTerminal';

const links = [
  {
    text: `Truck fill and time`,
    path: '/customer',
    Icon: LocalShippingIcon,
  },
  {
    text: `Information from Traffic`,
    path: '/customer/info-from-traffic',
    Icon: InfoIcon,
  },
  {
    text: `Fixed Traffic Overview`,
    path: '/customer/fixed-traffic-overview',
    Icon: CalendarTodayIcon,
  },
  {
    text: 'CMR',
    path: '/customer/cmr',
    Icon: GridOnIcon,
  },
  {
    text: 'Remaining Goods',
    path: '/customer/remaining-goods',
  },
  {
    text: 'Report to traffic',
    path: '/customer/report-to-traffic',
    Icon: SummarizeIcon,
  },
];

interface CustomerPageContentProps {
  user?: {
    location?: Maybe<{
      id: number;
      name: string;
      shortCountryCode: string;
    }>;
  };
}

export function CustomerPageContent() {
  const user: CustomerPageContentProps['user'] = {
    location: {
      id: 81,
      name: 'ELGIGANTEN LOGISTIK',
      shortCountryCode: 'se',
    },
  };
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  return (
    <Layout drawerLinks={links} pageName={t('pages.customer.title')}>
      <BreadCrumbs />
      <Switch>
        {user && user.location != null && (
          <>
            <Route path={`${path}/`} exact>
              <TruckFillAndTime location={user?.location} />
            </Route>
            <Route path={`${path}/info-from-traffic`} exact>
              <ViewReportFromTerminal location={user.location} />
            </Route>
            <Route path={`${path}/fixed-traffic-overview`} exact>
              <FixedTrafficOverview location={user?.location} />
            </Route>
            {/* CMR */}
            <Route path={`${path}/cmr`}>
              <ManualCMR />
            </Route>
            {/* Remaining goods */}
            <Route path={`${path}/remaining-goods`} exact>
              <RemainingGoodsInTerminal location={user?.location} />
            </Route>
            {/* ReportToTraffic */}
            <Route path={`${path}/report-to-traffic`} exact>
              <ReportToTrafficInTerminal location={user?.location} />
            </Route>
            {/* <Route path={`${path}/change-terminal`}>
              <SelectTerminal />
            </Route> */}
            {/* <Route exact path={`${path}/cards/terminals/:id`}>
              <ViewTerminal terminal />
            </Route> */}{' '}
            {/* <Route exact path={`${path}/cards/customers/:id`}>
              <ViewCustomer terminal />
            </Route> */}{' '}
            {/* <Route exact path={`${path}/cards/subcontractors/:id`}>
              <ViewSubcontractor terminal />
            </Route> */}
            {/* <Route exact path={`${path}/cards/checkpoints/:id`}>
              <ViewCheckpoint terminal />
            </Route> */}
          </>
        )}
      </Switch>
    </Layout>
  );
}
